// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".city-filter {\n  display: inline-block;\n  margin-left: 20px;\n}\n.city-filter .ant-select {\n  width: 120px;\n}\n", ""]);
// Exports
module.exports = exports;
